// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3t6IL","inputDescription":"styles_inputDescription__-zL7G"};